import { create } from 'zustand';

/** T-0 source: a selected launch, or an operator-entered time */
export type CountdownMode = 'launch' | 'manual';

interface CountdownState {
  /** Which T-0 source is active */
  mode: CountdownMode;
  /** Selected launch id (mode 'launch') */
  selectedLaunchId: string | null;
  /** Operator-entered T-0 as an ISO string (mode 'manual') */
  manualT0: string | null;
  /** Current time in epoch ms, updated once per second while ticking */
  nowMs: number;
  /** Select a launch as the T-0 source */
  selectLaunch: (id: string) => void;
  /** Set a manual T-0 (ISO), or clear it */
  setManualT0: (iso: string | null) => void;
  /** Begin the shared 1 Hz ticker (ref-counted) */
  startTicking: () => void;
  /** Release the shared ticker */
  stopTicking: () => void;
}

/** Single shared interval driving all countdown displays */
let ticker: ReturnType<typeof setInterval> | null = null;
let subscribers = 0;

/** Store holding the countdown selection and a shared 1 Hz clock. */
export const useCountdownStore = create<CountdownState>((set) => ({
  mode: 'launch',
  selectedLaunchId: null,
  manualT0: null,
  nowMs: Date.now(),
  selectLaunch: (id) => set({ mode: 'launch', selectedLaunchId: id }),
  setManualT0: (iso) => set({ mode: 'manual', manualT0: iso }),
  startTicking: () => {
    subscribers += 1;
    if (ticker) return;
    ticker = setInterval(() => set({ nowMs: Date.now() }), 1000);
  },
  stopTicking: () => {
    subscribers = Math.max(0, subscribers - 1);
    if (subscribers === 0 && ticker) {
      clearInterval(ticker);
      ticker = null;
    }
  },
}));
